import React, { useContext } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { HomepageContext } from '../context';

const TopServices = () => {
  const { featured } = useContext(HomepageContext);
  const items = featured;

  if (items && items.length > 0) {
    return (
      <div className="TopServices">
        <Container>
          <Row>
            <Col>
              <h2 className="SectionHeading">
                Featured services
                <Link to="!#">Browse All</Link>
              </h2>
              <Row>
                {
                  items.map((item, index) => (
                    <Col xs={6} key={index}>
                      <div className="TopServices-Item">
                        <Row>
                          <Col lg={6}>
                            <Link to="/">
                              <Image 
                                fluid 
                                src={item.image} 
                                alt={item.name} 
                                className="TopServices-Item__Image shadow-sm"
                              />
                            </Link>
                          </Col>
                          <Col lg={6}>
                            <Link to="/" className="TopServices-Item__Title">
                              <h5 className="mb-2">{item.name}</h5>
                            </Link>
                            <p className="TopServices-Item__Details">{item.details}</p>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ))
                }
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return null;
};

export default TopServices;